import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, useAuth } from "@/auth/AuthContext";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate("/members", { replace: true, state: { user: data } });
      } catch {
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { authError: true } });
      }
    })();
  }, [location, navigate, setUser]);

  return <div className="auth-callback" data-testid="auth-callback"><span className="pulse-dot" /> Signing you in…</div>;
}
